import { render } from "./a-menu-navigation.vue?vue&type=template&id=b0a03222&scoped=true"
import script from "./a-menu-navigation.vue?vue&type=script&lang=js"
export * from "./a-menu-navigation.vue?vue&type=script&lang=js"

import "./a-menu-navigation.vue?vue&type=style&index=0&id=b0a03222&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a03222"]])

export default __exports__